import { initializeImg } from '@src/telemetry/integrations/provider-utils/initialize-img'
import type { TelemetryIntegration } from '@src/telemetry/telemetry-events.types'

import { TELEMETRY_DOMAINS } from '../telemetry-domains.constants'
import { TELEMETRY_EVENT_NAMES } from '../telemetry-events.constants'
import TrustArcCl from './trustarc'

export let getImgSrc: (type: string) => string

export const Claritas: TelemetryIntegration = {
  initialize: () => {
    const randomOrd = Math.random() * 10000000000000
    getImgSrc = (type: string) =>
      `${TELEMETRY_DOMAINS.CLARITAS}/pixel/conv/ppt=22167;g=${type};gid=51556;ord=${randomOrd};v=120`
  },

  config: {
    enabled: true,
    eventIdealTimeout: 1000,
    domain: TELEMETRY_DOMAINS.CLARITAS,
  },
  events: {
    [TELEMETRY_EVENT_NAMES.PAGE_VIEW]: () => {
      initializeImg({
        id: `claritas_all_pages`,
        src: getImgSrc?.('all_pages'),
        width: '1',
        height: '1',
      })
    },

    [TELEMETRY_EVENT_NAMES.ADD_TO_CART]: () => {
      initializeImg({
        id: `claritas_add_to_cart`,
        src: getImgSrc('add_to_cart'),
        width: '1',
        height: '1',
      })
    },
  },
}
